/*
 *
 * ForgotPasswordPage RequestForm
 *
 */

import React from "react";
import { StyledForm, ButtonGroup } from "./styledComponents";

import Button from "components/Button";
import InputField from "components/InputField";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { t } from "copy/t";

const schema = yup
  .object({
    email: yup.string().email(),
  })
  .required();

const RequestForm = ({ onSubmit, pristine, submitting }) => {
  const form = useForm({
    resolver: yupResolver(schema),
  });
  const {
    control,
    formState: { errors },
  } = form;

  return (
    <StyledForm onSubmit={form.handleSubmit(onSubmit)}>
      <Controller
        control={control}
        name="email"
        render={({ field: { ref, ...fieldRest } }) => (
          <InputField
            name="email"
            type="email"
            label="Email Address"
            placeholder={t("placeholders.email")}
            field={fieldRest}
            {...fieldRest}
            errorMsg={errors?.email?.message}
          />
        )}
      />
      <ButtonGroup>
        <Button type="submit" disabled={submitting}>
          Start Password Reset
        </Button>
      </ButtonGroup>
    </StyledForm>
  );
};

export default RequestForm;
